import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import './view.scss';

document.querySelectorAll( '[data-solution-carousel]' ).forEach( ( element ) => {
	const slider = element.querySelector( '.swiper' );

	if ( ! slider ) {
		return;
	}

	new Swiper( slider, {
		modules: [ Navigation, Scrollbar ],
		slidesPerView: 'auto',
		spaceBetween: window.matchMedia( '(min-width: 768px)' ).matches ? 20 : 16,
		speed: 500,
		navigation: {
			prevEl: element.querySelector( '[data-slider-prev]' ),
			nextEl: element.querySelector( '[data-slider-next]' ),
		},
		scrollbar: {
			el: element.querySelector( '[data-slider-progress]' ),
			draggable: true,
		},
	} );
} );
